import { render, staticRenderFns } from "./UsuarioEscala.vue?vue&type=template&id=42beaafd&"
import script from "./UsuarioEscala.vue?vue&type=script&lang=js&"
export * from "./UsuarioEscala.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports